<template>
    <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Nazwa" v-model="name"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea v-model="description" rows="7" label="Opis"></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-select label="Typ opisu:" v-model="type" :items="types"></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-combobox
                                v-model="selectedCategories"
                                :items="categories"
                                deletable-chips
                                label="Kategorie"
                                item-text="description"
                                item-value="id"
                                multiple
                                chips
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-row v-if="$can('do','POKO_Opisy_Ogolne_Dodawanie')">
                    <v-col cols="12">
                        <v-checkbox v-model="is_public" label="Czy to opis ogólny?"></v-checkbox>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="save()" color="success">Zapisz</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="closeForm()" color="error">Zamknij</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import swal from "sweetalert";
    import {descriptionService} from "../../services";

    export default {
        name: "DescriptionEdit",
        props: ["editedObject", "categories"],
        data() {
            return {
                type: null,
                description: null,
                selectedCategories: [],
                name: null,
                is_public: false,
                title: 'Dodawanie opisu',
                types: [
                    {value: 0 , text: 'Rozpoznanie'},
                    {value: 1, text: 'Zalecenia'},
                    {value: 2, text: 'Przebieg'}
                ]
            }
        },
        methods: {
            save() {
                    let categories = []
                    if(!this.name)
                    {
                        this.showError(false, 'Proszę podać nazwę opisu.')
                        return
                    }
                    if(!this.description)
                    {
                        this.showError(false,'Proszę podać treść opisu.')
                        return
                    }
                    if(this.type == null)
                    {
                        this.showError(false,'Proszę wybrać typ opisu.')
                        return
                    }
                    if(this.selectedCategories && this.selectedCategories.length > 0)
                    {
                        this.selectedCategories.forEach(elem=> {
                            categories.push(elem.id)
                        })
                    }
                    if(this.editedObject == null) {
                        descriptionService.addDescription({
                            isPrivate: !this.is_public,
                            description: this.description,
                            type: this.type,
                            name: this.name,
                            categories: categories
                        }).then(() => {
                            this.closeForm()
                        }).catch(() => {
                            this.showError(false, "Błąd zapisu opisu.")
                        })
                    }
                    else
                    {
                        descriptionService.updateDescription({
                            id: this.editedObject.id,
                            description: this.description,
                            isPrivate: !this.is_public,
                            type: this.type,
                            name: this.name,
                            categories: categories
                        }).then(() => {
                            this.closeForm()
                        }).catch(() => {
                            this.showError(false, "Błąd zapisu opisu.")
                        })
                    }

            },
            closeForm() {
                this.$emit('close')
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
        },
        watch: {
            editedObject: {
                immediate: true,
                handler(val) {
                    this.selectedCategories = []
                    this.description = null
                    this.type = null
                    this.is_public = false

                    if(val != null)
                    {
                        this.title = 'Edycja opisu'
                        this.description = val.description
                        this.type = val.description_type
                        this.is_public = !val.is_private

                        if(val.categories != null && val.categories.length > 0)
                        {
                            val.categories.forEach(elem => {
                                var fc = this.categories.find(x=>x.id == elem.id)
                                if(fc != null)
                                {
                                    this.selectedCategories.push(fc)
                                }
                            })
                        }

                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>